import queryString from 'query-string';
import { autorun } from 'mobx';
import { isResponseReferralSocket } from 'src/domains/sportsbook/betting/betting/getReferredBetSlipTypes';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { WebsocketV1 } from 'src/domains/layouts/state/websocketV1/WebsocketV1';
import { AccountState } from 'src/domains/players/state/accountState/AccountState';
import { Common } from 'src/domains/common/Common';
import { starAppStateInitAddToBetslip } from './starAppStateInitAddToBetslip';
import { MessageBoxState } from 'src/domains/players/state/MessageBoxState';
import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import { IsStaticState } from 'src/domains/layouts/state/isStaticState/IsStaticState';

const run = (callback: () => void): void => {
    callback();
};

export function mapBetsToAmount<T>(configComponents: ConfigComponents, bets: T): T {
    const elementsToTransform = [
        'potentialReturns',
        'stakePerLine',
        'totalStake',
        'operatorTotalStake',
        'operatorStakePerLine',
        'maxBet',
    ];
    // @ts-expect-error
    bets = bets.map((bet) => {
        for (const key of elementsToTransform) {
            let element = bet[key];
            console.log('mapBetsToAmount-element', element);
            if (element !== undefined && element !== null) {
                element = configComponents.precision.newFromAnything(element).value;
                bet[key] = element;
            }
        }
        return bet;
    });

    return bets;
}

export const starAppStateInit = (common: Common): void => {
    const urlParams = common.isBrowser ? queryString.parse(window.location.search) : null;

    starAppStateInitAddToBetslip(common, urlParams);

    run(() => {
        autorun((reaction) => {
            const { userId } = common.session;
            const websocketV1 = WebsocketV1.get(common);
            const configComponents = ConfigComponents.get(common);

            if (userId !== null) {
                websocketV1.subscribeOldVersionToDelete(`${userId}:RefBet`, async (data: unknown): Promise<void> => {
                    const accountState = AccountState.get(common);
                    await accountState.account?.refreshAll();
                    // Temporary solution - to remove after ws v1

                    const referredBetsWithNewStakePerLine = mapBetsToAmount(
                        configComponents,
                        // @ts-expect-error
                        data.body.referredBetslip.bets
                    );

                    const betsWithNewStakePerLine = mapBetsToAmount(
                        configComponents,
                        // @ts-expect-error
                        data.body.bets
                    );
                    // @ts-expect-error
                    data.body.referredBetslip.bets = referredBetsWithNewStakePerLine;
                    // @ts-expect-error
                    data.body.bets = betsWithNewStakePerLine;
                    if (isResponseReferralSocket(data)) {
                        await AppSportsBookState.get(common).betSlipState.referralState.handleBetReferralData(data);
                    } else {
                        // @ts-expect-error
                        await AppSportsBookState.get(common).betSlipState.referralState.handleBetReferralData(data);
                    }
                    reaction.dispose();
                });
            }
        });
    });

    run(() => {
        let prevUser: number | null = null;
        autorun(() => {
            const userId = common.session.userId;

            if (prevUser !== null && userId === null) {
                MessageBoxState.get(common).runActionNotLogged();
            }

            prevUser = userId;
        });
    });

    run(() => {
        const dispose = autorun(() => {
            const isStatic = IsStaticState.get(common).isStatic;

            if (isStatic) {
                document.documentElement.classList.add('is-static');
            } else {
                document.documentElement.classList.remove('is-static');
            }
        });

        return (): void => {
            dispose();
        };
    });
};
